export const environment = {
  production: false,
  servicesUrl: 'https://preprod.app.cavernedugobelin.fr/services',
  imgUrl: 'https://preprod.app.cavernedugobelin.fr/img',
  recaptcha: {
    siteKey: '6LfoSzkqAAAAAJVUN27m--sb3JyaBAbu8mDfSoxU',
  },
  mr_api_enseigne: 'CC22QOYM',
  urlMonetico: 'https://p.monetico-services.com/test/paiement.cgi',
  menuIdents: {
    used: '68e66ac1ee4a1',
    crush: '671e72361f8b4',
    promos: '671e72361fd0a',
    news: '671e723620170',
    preorder: '671e72361ff3f',
    goldnGob: '67f6133b0bac8',
  }
};
